export const supaConfig = {
	apiKey: 'sb_publishable_et_Yg89v2MUz3oqVFWET-A_uiQsdyFO',
	contactsURL: 'https://sxslihzkqoluiyshicbs.supabase.co/rest/v1/contacts_list'
}